import { createContext, useContext, useEffect } from 'react'

/**
 * Lets a child screen drive the topbar: override the title and show a back button,
 * so detail screens (a report, a bank statement) keep their heading and "back" up
 * in the header instead of repeating them in the body. The body is then pure
 * content. Top-level list pages don't need this — their title comes from the route.
 */
export interface PageHeader {
  title?: string
  /** A route to go back to; renders a back arrow before the title. */
  backTo?: string
}

export const PageHeaderContext = createContext<(header: PageHeader | null) => void>(() => {})

/** Sets the topbar title / back target for the current screen; clears on unmount. */
export function usePageHeader(header: PageHeader): void {
  const set = useContext(PageHeaderContext)
  const { title, backTo } = header
  useEffect(() => {
    set({ ...(title ? { title } : {}), ...(backTo ? { backTo } : {}) })
    return () => set(null)
  }, [set, title, backTo])
}
